module.exports = __webpack_public_path__ + "static/media/gainon-screen.814c71e5.svg";